import { ArtBundle } from '../types';

export function getArtBundleById(artBundles: ArtBundle[] = [], id: string): ArtBundle | undefined {
  return artBundles.find((artBundle: ArtBundle) => artBundle?.properties?.section_id === id);
}
